// W8ED programmes. Nothing here is live unless its status says LIVE.
export const PROGRAMMES = [
  {
    id: "w8ed-nutrition",
    name: "W8ED NUTRITION",
    status: "IN DEVELOPMENT",
    pillar: "nutrition",
    whoFor: "People who want to fix the most repeated signal first — what they eat, every day.",
    duration: "12 weeks",
    methodology: "Nutrition structured around the eight-pillar system: food quality, protein, fibre, energy and eating behaviour — repeated and reviewed over time.",
    measured: "Consistency, eating behaviour, energy, and metabolic markers where available.",
    included: "A structured nutrition framework, W8ED product integration, and periodic review.",
    journey: "Assess → Structure → Repeat → Review → Adapt.",
    outcomes: "A repeatable way of eating — built to hold up over months and years, not a diet built to end.",
  },
  {
    id: "w8ed-metabolic",
    name: "W8ED METABOLIC",
    status: "COMING SOON",
    pillar: "metabolism",
    whoFor: "People who want to understand the engine — energy, glucose, fuel use and flexibility.",
    duration: "To be announced",
    methodology: "Metabolic health approached through the system: nutrition, movement, muscle, sleep, stress and recovery — not a single metric.",
    measured: "To be announced",
    included: "To be announced",
    journey: "Assess → Structure → Repeat → Review → Adapt.",
    outcomes: "Built around sustainable metabolic signals, not short-term fixes.",
  },
  {
    id: "w8ed-performance",
    name: "W8ED PERFORMANCE",
    status: "COMING SOON",
    pillar: "movement",
    whoFor: "People building physical capacity — strength, muscle, movement and recovery together.",
    duration: "To be announced",
    methodology: "Capacity-first programming: movement and muscle supported by nutrition, sleep and recovery.",
    measured: "To be announced",
    included: "To be announced",
    journey: "Assess → Structure → Repeat → Review → Adapt.",
    outcomes: "Strength and capacity that compound — with recovery built in, not bolted on.",
  },
  {
    id: "w8ed-longevity",
    name: "W8ED LONGEVITY",
    status: "COMING SOON",
    pillar: "sleep",
    whoFor: "People playing the long game — health as something built across decades.",
    duration: "To be announced",
    methodology: "The eight pillars viewed explicitly through time: accumulation, adaptation and ageing.",
    measured: "To be announced",
    included: "To be announced",
    journey: "Assess → Structure → Repeat → Review → Adapt.",
    outcomes: "A long-horizon system for health — not a short-horizon intervention.",
  },
];

export const programmeById = (id) => PROGRAMMES.find((p) => p.id === id);
